import { useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const APP_VERSION = '2.1.0';

function getOrCreateSessionId() {
  const key = 'pmi_session_id';
  let sessionId = localStorage.getItem(key);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem(key, sessionId);
  }
  return sessionId;
}

function hasConsent() {
  return localStorage.getItem('pmi_analytics_consent') === 'true';
}

export function useAnalytics() {
  const track = useCallback(async (eventType, payload = {}) => {
    if (!hasConsent()) return;
    try {
      await fetch(`${API_URL}/api/analytics/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: getOrCreateSessionId(),
          event_type: eventType,
          market: payload.market || null,
          sector_bucket: payload.sector_bucket || null,
          ui_surface: payload.ui_surface || 'unknown',
          app_version: APP_VERSION,
        }),
      });
    } catch {
      // Silent fail - analytics should never break the app
    }
  }, []);

  return { track, getOrCreateSessionId };
}
